import React from 'react'
import ContactForm from '../../component/ContactUs/ContactUsForm/ContactForm'
import OurOffices from '../../component/ContactUs/OurGlobalNetwork/OurOffices'
import ContactUsHeader from '../../component/ContactUs/ContactUsHeader/ContactUsHeader'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import ContactusBannerHeader from '../../component/ContactUs/ContactUsHeader/ContactusBannerHeader'
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'

const ContactUsPage = () => {
  return (
    <>
    <ToastContainer />
    <ContactusBannerHeader />
    <ContactUsHeader /> 
    <FloatingContactUs />
    <ContactForm />
    <OurOffices />
    </>
  )
}

export default ContactUsPage